__webpack_require__.p = "https://ikea.marat.qd.je/au/en/customer-service/support/";